import RenderOptions from "./renderOptions";

export default {
    __init__ : ['renderingOptions'],
    renderingOptions: ['type', RenderOptions],
};